import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuditLog } from '../model/audit-log.model';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-audit-log',
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.scss']
})
export class AuditLogComponent implements OnInit {
  displayedColumns: string[] = ['auditId', 'performedAt', 'performedBy', 'entityType', 'entityId', 'action', 'fieldName', 'oldValue', 'newValue', 'description'];
  dataSource = new MatTableDataSource<AuditLog>();
  isLoading = false;
  searchValue = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private apiService: ApiService, private snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.loadLogs();
  }

  loadLogs(): void {
    this.isLoading = true;
    this.apiService.getAuditLogs().subscribe(
      (data: any) => {
        this.dataSource.data = data || [];
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
        this.snackBar.open('Error loading audit logs', 'Close', { duration: 3000 });
      }
    );
  }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
